import React from 'react';
import { Button } from '@/components/ui/button';
import { RotateCcw } from 'lucide-react';
import { MultiSelectFilter } from './MultiSelectFilter';
import { DateRangeFilter } from './DateRangeFilter';

export const MULTI_FILTERS = [
  ['suppliers', 'Supplier', 'suppliers'],
  ['po_numbers', 'PO Number', 'po_numbers'],
  ['grn_numbers', 'GRN Number', 'grn_numbers'],
  ['skus', 'Product ID / SKU', 'skus'],
  ['product_names', 'Product Name', 'product_names'],
  ['categories', 'Product Category', 'categories'],
  ['brands', 'Brand', 'brands'],
  ['po_statuses', 'PO Status', 'po_statuses'],
  ['recon_statuses', 'Reconciliation Status', 'recon_statuses'],
  ['exception_types', 'Exception Type', 'exception_types'],
  ['severities', 'Exception Severity', 'severities'],
  ['warehouses', 'Warehouse / Store', 'warehouses'],
  ['users', 'Created / Approved By', 'users'],
];

const DATES = [['po_date', 'PO Date'], ['grn_date', 'GRN Received Date']];

export const GlobalFilters = ({ filters, setFilters, options, onReset }) => {
  const set = (k, v) => setFilters((f) => ({ ...f, [k]: v }));
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-3" data-testid="po-grn-filters">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {DATES.map(([k, label]) => (
          <DateRangeFilter key={k} label={label} from={filters[`${k}_from`]} to={filters[`${k}_to`]} preset={filters[`${k}_preset`]}
            onChange={({ from, to, preset }) => setFilters((f) => ({ ...f, [`${k}_from`]: from, [`${k}_to`]: to, [`${k}_preset`]: preset }))}
            testId={`filter-${k.replace(/_/g, '-')}`} />
        ))}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3">
        {MULTI_FILTERS.map(([k, label, optKey]) => (
          <MultiSelectFilter key={k} label={label} options={options?.[optKey] || []} value={filters[k] || []}
            onChange={(v) => set(k, v)} testId={`filter-${k.replace(/_/g, '-')}`} />
        ))}
        <div className="flex items-end">
          <Button variant="outline" className="h-9 w-full gap-2" onClick={onReset} data-testid="filters-reset-btn">
            <RotateCcw size={14} /> Reset
          </Button>
        </div>
      </div>
    </div>
  );
};
